var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChimney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.467,
    height: 16.535,
    viewBox: "0 0 18.467 16.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6c757d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.152,18.9a.664.664,0,0,0-.464-.089l-.149-7.257a.665.665,0,0,0-.665-.651H14.942a.665.665,0,0,0-.665.651l-.157,7.633a.662.662,0,0,0-.9-.318l-.352.175v-3.8a.665.665,0,0,0-.665-.665h-.8a.665.665,0,0,0-.665.665v4.862l-.837.418V19.461a.665.665,0,0,0-.962-.595L5.614,20.523V19.461a.665.665,0,0,0-.962-.595L.368,21A.665.665,0,0,0,0,21.6v5.171a.665.665,0,0,0,.665.665H17.8a.665.665,0,0,0,.665-.665V19.461A.665.665,0,0,0,18.152,18.9ZM3.737,25.153a.665.665,0,0,1-.665.665h-1.2a.665.665,0,0,1-.665-.665v-.827a.665.665,0,0,1,.665-.665h1.2a.665.665,0,0,1,.665.665Zm5.1,0a.665.665,0,0,1-.665.665h-1.2a.665.665,0,0,1-.665-.665v-.827a.665.665,0,0,1,.665-.665h1.2a.665.665,0,0,1,.665.665Zm5.1,0a.665.665,0,0,1-.665.665h-1.2a.665.665,0,0,1-.665-.665v-.827a.665.665,0,0,1,.665-.665h1.2a.665.665,0,0,1,.665.665Z",
    transform: "translate(0 -10.899)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChimney);
export default __webpack_public_path__ + "static/media/chimney.4240f11f2af122e64b0f1284ec3f7fc9.svg";
export { ForwardRef as ReactComponent };